import React from 'react';
import { ContextValue } from './types';

export const BrazeContext = React.createContext<ContextValue>({
  isBrazeInitialized: false,
  inAppMessages: [],
  inAppMessageClick: () => {},
  removeMessage: () => {},
});
